import { Text } from '@thanx/uikit/text'
import { useGetSuppressionsQuery } from 'api/suppressions'
import Cell from 'components/Cell'
import ContentContainer from 'components/ContentContainer'
import HeaderCell from 'components/HeaderCell'
import InfoBox from 'components/InfoBox'
import Section from 'components/Section'
import { buildTranslate } from 'locales'
import moment from 'moment-timezone'
import React from 'react'
import { useUserTimeZone } from 'utilities/userTimeZone'

const t = buildTranslate('suppressions')

type Props = {
  className?: string
}

const RecentSuppressions: React.FC<Props> = ({ className = '' }) => {
  const { data, isLoading, isError } = useGetSuppressionsQuery()
  const timeZone = useUserTimeZone()
  const suppressions = data?.suppressions ?? []

  return (
    <div className={className}>
      <InfoBox
        type="info"
        content={
          <span dangerouslySetInnerHTML={{ __html: t('compliance_notice') }} />
        }
        className="mb-m"
      />
      <Section>
        <ContentContainer isLoading={isLoading} isErrored={isError}>
          {suppressions.length === 0 ? (
            <div className="p-xl text-center">
              <Text.BodyText4 color="grey50">{t('empty')}</Text.BodyText4>
            </div>
          ) : (
            <table className="full-width">
              <thead>
                <tr className="border-bottom-1 grey-20-border">
                  <HeaderCell>{t('columns.identifier')}</HeaderCell>
                  <HeaderCell>{t('columns.suppressed_at')}</HeaderCell>
                </tr>
              </thead>
              <tbody>
                {suppressions.map(suppression => (
                  <tr
                    key={suppression.id}
                    className="border-bottom-1 grey-20-border"
                  >
                    <Cell>{suppression.identifier ?? '—'}</Cell>
                    <Cell>
                      {moment
                        .tz(suppression.suppressed_at, timeZone)
                        .format('MMM DD, YYYY')}
                    </Cell>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </ContentContainer>
      </Section>
    </div>
  )
}

export default RecentSuppressions
